"use client";
import React from "react";
import {
  FontColor,
  ThemeBasedColorHeader,
  ThemeBasedColorMenubar,
} from "src/shared/modules/profile/theme/themeCheacker";

export interface ButtonProps {
  label?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  variant?:
  | "ThemeBase"
  | "ThemeCancel"
  | "primary"
  | "secondary"
  | "danger"
  | "confirm"
  | "cancel"
  | "custom"
  | "light";
  icon?: React.ElementType;
  disabled?: boolean;
  className?: string;
  font?: string;
  radius?: string;
  size?: "sm" | "md" | "lg";
  iconPosition?: "left" | "right";

}

export const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  type = "button",
  variant = "primary",
  icon: Icon,
  disabled = false,
  className = "",
  font = "font-medium",
  radius = "rounded-md",
  iconPosition = "left",
  size = "md",
}) => {
  const variantStyles: Record<string, string> = {
    primary: "bg-blue-600 hover:bg-blue-700 text-white",
    secondary: "bg-gray-300 hover:bg-gray-400 text-black",
    danger: "bg-red-600 hover:bg-red-700 text-white",
    confirm: "bg-green-600 hover:bg-green-700 text-white",
    cancel: "bg-yellow-500 hover:bg-yellow-600 text-white",
    custom: "", // No default styles here!
    ThemeBase: ThemeBasedColorHeader() || "",
    ThemeCancel: FontColor() || "",
    light: ThemeBasedColorMenubar() || "",
  };

  const finalClasses =
    variant === "custom"
      ? `${className} ${font} ${radius}`
      : `${variantStyles[variant]} ${className} ${font} ${radius}`;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        flex items-center justify-center gap-2 px-4 py-2
        transition-all duration-200
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        ${finalClasses}
      `}
    >
      {Icon && iconPosition === "left" && <Icon className={size === "sm" ? "h-4 w-4" : "h-5 w-5"} />}
      {label && <span>{label}</span>}
      {Icon && iconPosition === "right" && <Icon className={size === "sm" ? "h-4 w-4" : "h-5 w-5"} />}

    </button>
  );
};
